export default {
  title: 'Enter email to get your personal Kegel Plan',
  disclaimer: 'Your personal data is safe with us. We\'ll use your email for updates, receipts, and subscription details.',
  placeholder: 'Enter your email',
  button: 'Continue'
}
